import React, { useCallback, useEffect, useState } from 'react';
import { creditsAPI } from '../services/api';
import { parseServerDate } from '../utils/serverDate';
import './CreditHistory.css';

const KIND_LABELS = {
  search: 'Search',
  verify: 'Email check',
  plan_grant: 'Plan credits',
  topup: 'Top-up',
  admin_adjust: 'Adjustment',
  topup_refund: 'Top-up refunded',
  plan_expire: 'Plan ended',
};

// `fetcher` lets the admin panel reuse this list for another user's history.
function CreditHistory({ fetcher, limit = 50 }) {
  const [rows, setRows] = useState(null);
  const [error, setError] = useState(false);

  const load = useCallback(async () => {
    try {
      const res = await (fetcher ? fetcher({ limit }) : creditsAPI.getHistory({ limit }));
      setRows(res.data.history || []);
      setError(false);
    } catch (err) {
      setError(true);
    }
  }, [fetcher, limit]);

  useEffect(() => { load(); }, [load]);

  if (error) return <p className="credit-history-empty">Couldn't load credit history.</p>;
  if (rows === null) return <p className="credit-history-empty">Loading…</p>;
  if (rows.length === 0) return <p className="credit-history-empty">No credit activity yet.</p>;

  return (
    <ul className="credit-history">
      {rows.map((r) => (
        <li key={r.id} className="credit-history-row">
          <span>
            <strong>{KIND_LABELS[r.kind] || r.kind}</strong>
            {r.note && <span className="credit-history-note"> · {r.note}</span>}
            <div className="credit-history-meta">
              {parseServerDate(r.created_at)?.toLocaleString() || ''}
            </div>
          </span>
          <span className="credit-history-amount">
            <strong className={r.delta < 0 ? 'credit-history-delta is-negative' : 'credit-history-delta is-positive'}>
              {r.delta > 0 ? '+' : ''}{r.delta.toLocaleString()}
            </strong>
            <div className="credit-history-meta">
              balance {(r.monthly_after + r.topup_after).toLocaleString()}
            </div>
          </span>
        </li>
      ))}
    </ul>
  );
}

export default CreditHistory;
